import Vue from 'vue'
import Router from 'vue-router'
//import integrationRoutes from '@/integrations/routes'

Vue.use(Router)

var routes = [
    {
      name: 'account',
      path: '/account/',
      component: () => import(/* webpackChunkName: "account" */ '@/pages/account').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'brands',
      path: '/brands/',
      component: () => import(/* webpackChunkName: "brands" */ '@/pages/brands').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      path: '/builds/',
      component: () => import(/* webpackChunkName: "undefined" */ '@/pages/builds').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'builds',
        path: '',
        component: () => import(/* webpackChunkName: "builds" */ '@/pages/builds/search').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'builds-submit',
        path: 'submit/',
        component: () => import(/* webpackChunkName: "builds-submit" */ '@/pages/builds/submit').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'builds-detail',
        path: ':buildId/',
        component: () => import(/* webpackChunkName: "builds-detail" */ '@/pages/builds/detail').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'builds-edit',
        path: ':buildId/edit/',
        component: () => import(/* webpackChunkName: "builds-edit" */ '@/pages/builds/edit').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'builds-confirm',
        path: ':buildId/confirm/',
        component: () => import(/* webpackChunkName: "builds-confirm" */ '@/pages/builds/confirm').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'category',
      path: '/c/:lvl0/:lvl1?/:lvl2?/:lvl3?/',
      meta: {"isFitable":true,"hasCustomFitment":true},
      component: () => import(/* webpackChunkName: "category" */ '@/pages/catalog').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'category-custom',
        path: 'f/:facetSlug/',
        meta: {"isFitable":true},
        pathToRegexpOptions: { strict: true },
        children: [
        {
          name: 'category-custom-mmy',
          path: 'v/:makeSlug/:modelSlug?/:year?/',
          pathToRegexpOptions: { strict: true },
        },
        ]
      },
      {
        name: 'category-mmy',
        path: 'v/:makeSlug/:modelSlug?/:year?/',
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'search',
      path: '/search/',
      meta: {"hasCustomFitment":true},
      component: () => import(/* webpackChunkName: "search" */ '@/pages/catalog').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'specials',
      path: '/specials/',
      meta: {"isFitable":true,"hasCustomFitment":true},
      component: () => import(/* webpackChunkName: "specials" */ '@/pages/catalog').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'specials-mmy',
        path: 'v/:makeSlug/:modelSlug?/:year?/',
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'new-products',
      path: '/new-products/',
      meta: {"isFitable":true,"hasCustomFitment":true},
      component: () => import(/* webpackChunkName: "new-products" */ '@/pages/catalog').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'new-products-mmy',
        path: 'v/:makeSlug/:modelSlug?/:year?/',
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'mmy',
      path: '/v/:makeSlug/:modelSlug?/:year?/',
      meta: {"hasCustomFitment":true},
      component: () => import(/* webpackChunkName: "mmy" */ '@/pages/catalog').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'brand',
      path: '/b/:brandSlug/',
      meta: {"isFitable":true,"hasCustomFitment":true},
      component: () => import(/* webpackChunkName: "brand" */ '@/pages/catalog').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'brand-mmy',
        path: 'v/:makeSlug/:modelSlug?/:year?/',
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'checkout',
      path: '/checkout/',
      meta: {"disableIntegration":["wisepops"]},
      component: () => import(/* webpackChunkName: "checkout" */ '@/pages/checkout').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'cart',
        path: 'cart/',
        meta: {"hideMiniCart":true},
        component: () => import(/* webpackChunkName: "checkout-cart" */ '@/pages/checkout/cart/').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'address',
        path: 'address/',
        meta: {"hideMiniCart":true},
        component: () => import(/* webpackChunkName: "checkout-address" */ '@/pages/checkout/address/').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'payment',
        path: 'payment/',
        meta: {"hideMiniCart":true},
        component: () => import(/* webpackChunkName: "checkout-payment" */ '@/pages/checkout/payment/').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'receipt',
        path: 'receipt/',
        meta: {"hideMiniCart":true},
        component: () => import(/* webpackChunkName: "checkout-receipt" */ '@/pages/checkout/receipt/').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      path: '/dealer-locator/',
      component: () => import(/* webpackChunkName: "undefined" */ '@/pages/dealerLocator').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'dealer-locator',
        path: '',
        component: () => import(/* webpackChunkName: "dealer-locator" */ '@/pages/dealerLocator/localDealers').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'dealer-locator-international',
        path: 'international/',
        component: () => import(/* webpackChunkName: "dealer-locator-international" */ '@/pages/dealerLocator/internationalDealers').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'order',
      path: '/order/',
      component: () => import(/* webpackChunkName: "order" */ '@/pages/order').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'order-status',
        path: 'status/:orderId/',
        component: () => import(/* webpackChunkName: "order-order-status" */ '@/pages/order/status').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'tracking',
        path: 'tracking/:trackingId/',
        component: () => import(/* webpackChunkName: "order-tracking" */ '@/pages/order/trackingDetails').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      path: '/orderstatus/',
      component: () => import(/* webpackChunkName: "undefined" */ '@/pages/order/redirect').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      path: '/paylink/:id/',
      component: () => import(/* webpackChunkName: "undefined" */ '@/pages/paylink').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'paylink',
        path: '',
        meta: {"hideMiniCart":true,"disableGlobalCartGet":true,"disableIntegration":["wisepops","chat"]},
        component: () => import(/* webpackChunkName: "paylink" */ '@/pages/paylink/routes/shipping').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'paylink-affirm',
        path: 'affirm/',
        meta: {"hideMiniCart":true,"disableGlobalCartGet":true,"disableIntegration":["wisepops","chat"]},
        component: () => import(/* webpackChunkName: "paylink-affirm" */ '@/pages/paylink/routes/affirm').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'paylink-payment',
        path: 'payment/',
        meta: {"hideMiniCart":true,"disableGlobalCartGet":true,"disableIntegration":["wisepops","chat"]},
        component: () => import(/* webpackChunkName: "paylink-payment" */ '@/pages/paylink/routes/payment').then(m => m.default || m),
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      path: '/test-no-api/',
      component: () => import(/* webpackChunkName: "perf-tests" */ '@/pages/perfTests/noApi.vue').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      path: '/test-with-api/',
      component: () => import(/* webpackChunkName: "perf-tests" */ '@/pages/perfTests/withApi.vue').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'product',
      path: '/p/:productLine/',
      meta: {"isFitable":true},
      component: () => import(/* webpackChunkName: "product" */ '@/pages/product').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
      children: [
      {
        name: 'product-mmy',
        path: 'v/:makeSlug/:modelSlug?/:year?/',
        pathToRegexpOptions: { strict: true },
      },
      {
        name: 'sku',
        path: ':skuSlug/',
        meta: {"isProductPage":true},
        pathToRegexpOptions: { strict: true },
      },
      ]
    },
    {
      name: 'lloyds',
      path: '/third-party/lloyds/',
      component: () => import(/* webpackChunkName: "third-party-configure-tech" */ '@/pages/product/_components/thirdParty/configureTech').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'dashdesigns',
      path: '/third-party/dashdesigns/',
      component: () => import(/* webpackChunkName: "third-party-configure-tech" */ '@/pages/product/_components/thirdParty/configureTech').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'rufftuff',
      path: '/third-party/rufftuff/',
      component: () => import(/* webpackChunkName: "third-party-configure-tech" */ '@/pages/product/_components/thirdParty/configureTech').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'avery',
      path: '/third-party/avery/',
      component: () => import(/* webpackChunkName: "third-party-configure-tech" */ '@/pages/product/_components/thirdParty/configureTech').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'wetokole',
      path: '/third-party/wetokole/',
      component: () => import(/* webpackChunkName: "third-party-configure-tech" */ '@/pages/product/_components/thirdParty/configureTech').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'caltrend',
      path: '/third-party/caltrend/',
      component: () => import(/* webpackChunkName: "third-party-caltrend" */ '@/pages/product/_components/thirdParty/caltrend').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'home',
      path: '/',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/content').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'pay',
      path: '/pay/',
      meta: {"hideMiniCart":true,"disableIntegration":["wisepops","chat"]},
      component: () => import(/* webpackChunkName: "pay" */ '@/pages/pay').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'restore-cart',
      path: '/restore-cart/',
      component: () => import(/* webpackChunkName: "restore-cart" */ '@/pages/restoreCart.vue').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'thank-you',
      path: '/thank-you/',
      component: () => import(/* webpackChunkName: "thank-you" */ '@/pages/thankYou').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'newsletter-unsubscribe',
      path: '/newsletter-unsubscribe/',
      component: () => import(/* webpackChunkName: "newsletter-unsubscribe" */ '@/pages/newsletter/unsubscribe/').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'installation-instructions',
      path: '/installation-instructions/',
      component: () => import(/* webpackChunkName: "installation-instructions" */ '@/pages/installationGuides').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'sales-reps',
      path: '/sales-contact/',
      component: () => import(/* webpackChunkName: "sales-reps" */ '@/pages/salesReps').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'affirmSuccess',
      path: '/affirm/success/',
      component: () => import(/* webpackChunkName: "affirm-landing" */ '@/integrations/affirm/affirmCheckoutResponse').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'affirmCancelled',
      path: '/affirm/cancelled/',
      component: () => import(/* webpackChunkName: "affirm-landing" */ '@/integrations/affirm/affirmCheckoutResponse').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'protex',
      path: '/protex/',
      meta: {"disableIntegration":["wisepops","chat"]},
      component: () => import(/* webpackChunkName: "protex" */ '@/integrations/protex/iframe').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
    {
      name: 'cms',
      path: '*',
      component: () => import(/* webpackChunkName: "cms" */ '@/pages/content').then(m => m.default || m),
      pathToRegexpOptions: { strict: true },
    },
]

export function createRouter() {
    const router = new Router({
        mode: 'history',
        routes,
        scrollBehavior(to, from, savedPosition) {
            // sometimes we don't want to update the scroll position on route change, like when moving to a ymm pline page from a pline page or when using #targets in cms pages
            if (to.params.noUpdateScroll || to.hash || from.hash) {
                delete to.params.noUpdateScroll
                return false
            }

            // nav forward
            if (!savedPosition) return { x: 0, y: 0 }
            // we have to delay a little bit because we can't scroll down the page of pages that are still loading crap (like Aloglia results or pline data)
            // TODO: Reduce this timeout once we have cache setup
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(savedPosition)
                }, 200)
            })
        },
    })
    return router
}
